export const firebaseConfig = {
    apiKey: "AIzaSyCrt_jTKOXaJU1dhclEXuWT7Q1bDu8_Vo8",
    authDomain: "dephyned-web.firebaseapp.com",
    databaseURL: "https://dephyned-web.firebaseio.com",
    projectId: "dephyned-web",
    storageBucket: "dephyned-web.appspot.com",
    messagingSenderId: "96018025824",
    appId: "1:96018025824:web:cc4b5e937e2521795ca205",
    measurementId: "G-KZCEP1TB7V"
};